import { AuthScreenType } from 'projects/visa-platform/src/app/shared/services/auth.interface';
import { environment } from 'projects/visa-platform/src/environments/environment';

export const ERROR_CODES = {
  CardNotEligible: 'CardNotEligible',
  CardAlreadyMappedWithUser: 'CardAlreadyMappedWithUser',
  InvalidUserCredentials: 'InvalidUserCredentials',
};

export const ERROR_MESSAGES = {
  [ERROR_CODES.CardAlreadyMappedWithUser]:
    environment.staticTextContents.loginModal.errorMsgs
      .cardAlreadyMappedWithEmail,
  [ERROR_CODES.CardNotEligible]:
    environment.staticTextContents.loginModal.errorMsgs.cardNotEligible,
  [ERROR_CODES.InvalidUserCredentials]:
    environment.staticTextContents.loginModal.errorMsgs.invalidUserCredentials,
};

export const TERMS_AND_CONDITIONS = {
  website: environment.webUrl,
  metaTitle: 'Terms and Conditions',
  metaDes: 'Terms and Conditions',
};

export const PRIVACY_POLICY = {
  metaTitle: 'Privacy Policy',
  metaDes: 'Privacy Policy',
};

export const AUTH_SCREENS: Record<string, AuthScreenType> = {
  Login: 'login',
  SignUp: 'signup',
};

export const BIN_STATUSES = {
  Created: 'created',
  BinVerified: 'bin_verified',
  Inactive: 'inactive',
  PaymentVerified: 'payment_verified',
  Verified: '3ds_verified',
};
